import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useDigitalOriginalsPage } from '../../../api/hooks/useDigitalOriginalsPage.hook';
import { Variant } from '../../../api/models/variant';
import { fetchVariants } from '../../../redux';
import { BasicCardVariants } from '../../../utils/_enums/basic-card-variants.enum';
import { FilterExpression } from '../../../utils/_enums/filter-expression.enum';
import { dateToISOString } from '../../../utils/_helper/time-helper';
import { useAppSelector } from '../../../utils/_hooks/hooks';
import { PaginationModel } from '../../../utils/_models/pagination-model';
import Teaser from '../../_shared/teaser/teaser';
import TeaserCard from '../../_shared/teaser-card/teaser-card';
import { SortingOptionsEnum } from "../../../utils/_enums/sorting-options.enum";
import { FilterItem } from "../../../utils/_models/filter-item";

const VariantsTeaser = (): JSX.Element => {
    const dispatch = useDispatch();
    const data = useDigitalOriginalsPage();
    const variants = useAppSelector<PaginationModel<Variant[]>>(
        (state) => state.productSlice.allVariants
    );
    const sorting = useAppSelector<SortingOptionsEnum>(
        (state) => state.productSlice.allVariantsSorting
    );

    useEffect(() => {
        fetchVariantsWithFilter(variants.pagination.page, 24);
    }, [sorting]);

    const getSorting = (value: SortingOptionsEnum): FilterItem => {
        switch (value) {
            case SortingOptionsEnum.TITLE_ASC:
                return {
                    value: 'title,asc',
                    param: 'sort',
                    comparisonType: FilterExpression.none
                }
            case SortingOptionsEnum.TITLE_DESC:
                return {
                    value: 'title,desc',
                    param: 'sort',
                    comparisonType: FilterExpression.none
                }
            case SortingOptionsEnum.DATE_ASC:
                return {
                    value: 'salesAttribute.saleFrom,asc',
                    param: 'sort',
                    comparisonType: FilterExpression.none
                }
            case SortingOptionsEnum.DATE_DESC:
                return {
                    value: 'salesAttribute.saleFrom,desc',
                    param: 'sort',
                    comparisonType: FilterExpression.none
                }
            default:
                return {
                    value: 'salesAttribute.saleFrom,desc',
                    param: 'sort',
                    comparisonType: FilterExpression.none
                }
        }
    }

    const fetchVariantsWithFilter = (page: number, size: number) => {
        const sortingObject = getSorting(sorting);
        dispatch(fetchVariants([
            {
                value: size.toString(),
                param: 'size',
                comparisonType: FilterExpression.none
            },
            {
                value: page.toString(),
                param: 'page',
                comparisonType: FilterExpression.none
            },
            {
                value: '0',
                param: 'mintingCount',
                comparisonType: FilterExpression.greaterThan
            },
            {
                value: encodeURIComponent(dateToISOString(new Date())),
                param: 'saleFrom',
                comparisonType: FilterExpression.lessThan
            },
            sortingObject
        ]));
    }

    if (data && variants?.data && variants.data.length > 0) {
        return (
            <div>
                <Teaser
                    headline={data.variantListHeadline.headlineContent}
                    maxCards={variants.maxNumber}
                    headlineElement={'h2'}
                    withNumbers={true}
                    initialCardIndex={variants.pagination.page}
                    hideTeaserButtons={true}
                    pending={variants.pending}
                    pagination={variants.pagination}
                    cards={variants.data.map((variant) => {
                            return <TeaserCard key={`variant-${variant.id}`} variant={variant}/>
                        }
                    )}
                    onLoadNewItems={(data) => {
                        fetchVariantsWithFilter(data.pageOrOffset, data.size);
                    }}
                    type={BasicCardVariants.BASIC_CARD_SMALL}
                />
            </div>
        );
    } else {
        return <div/>;
    }
};

export default VariantsTeaser;
